// src/components/common/PhoneInput.jsx
import React from 'react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import './PhoneInput.css';

const CustomPhoneInput = ({ value, onChange, placeholder = 'XXXXXXXXX', className = '', disabled = false }) => {
	return (
		<div className={`phone-input-wrapper ${className}`}>
			<PhoneInput
				international
				defaultCountry='GH'
				value={value}
				onChange={onChange}
				disabled={disabled}
				placeholder={placeholder}
				className='phone-input-custom'
			/>
		</div>
	);
};

export default CustomPhoneInput;
